import inputData from './inputData/beta-product-feedback-survey';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'beta-product-feedback-survey',
  title: 'Beta Product Feedback Survey',
  description: `Gather insights from early testers to understand what's working—and what needs refinement before launch.`,
  image: '/images/templates/beta-product-feedback-survey.png',
  tags: ['get-feedback', 'product', 'marketing'],
  inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

